;(function () {
  const scrollTopBtn = document.querySelector('.article-scroll-top')
  console.log(scrollTopBtn)
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    })
  }

  const goBackBtn = document.querySelector('[data-go-back]')
  if (goBackBtn) {
    goBackBtn.addEventListener('click', () => {
      window.history.back()
    })
  }
})()
